function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { withRouter } from "react-router";
import { DetailContainer } from "../../components/container-activity";
import { BaseDataViewComponent } from "../../components/base";
import publishSearch from '../../functions/publish-search';
import publishEvent from "../../functions/publish-event";
import { MDCTextInput, MDCFileUpload } from '../../../jsx/components/mdc-components';
import { AlertMessage } from '../../ui/alert';
import ProgressSuccess from '../../ui/progress/success';
import endpoints from "../../endpoints";
import account from "../../data/account";
import { manageDataLegacyHere } from "../../functions/tenant-features";
import { downloadTemplate, LOCATION_COLUMNS } from "../../functions/csv-templates";
class MainComponent extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "onChange", event => {
      var target = event.target;
      var value = target.value;
      this.setState({
        location: value
      });
    });
    _defineProperty(this, "onGoBack", () => {
      this.props.history.goBack();
    });
    _defineProperty(this, "onFocus", event => {
      this.setState({
        showMessage: false,
        messageType: '',
        message: null
      });
    });
    _defineProperty(this, "onDownloadTemplate", event => {
      downloadTemplate("locations-template.csv", LOCATION_COLUMNS);
    });
    _defineProperty(this, "onUploadError", obj => {
      this.count = 0;
      this.setState({
        showMessage: true,
        messageType: 'error',
        message: 'Error: Error uploading file.'
      });
    });
    _defineProperty(this, "onUploadComplete", obj => {
      this.count = 0;
      this.setState({
        showSuccess: true,
        showMessage: false,
        messageType: '',
        message: null
      });
    });
    _defineProperty(this, "onUploadProgressComplete", () => {
      this.setState({
        showMessage: true,
        messageType: '',
        message: 'Processing uploaded file.'
      });
    });
    _defineProperty(this, "onBeforeUpload", files => {
      //await Plunk360Service.refreshTokenCheckAsync();
      //
      this.handleUpload(files);
    });
    _defineProperty(this, "handleUpload", files => {
      if (this.count > 0) return false;
      var location = this.state.location;
      if (!location) {
        this.count = 0;
        this.upload.reset();
        this.setState({
          showMessage: true,
          messageType: 'error',
          message: 'Error: Location List Name Required.'
        });
        return false;
      }
      var headers = [{
        key: 'authorization',
        value: ''
      }, {
        key: 'X-APP-ID',
        value: this.state.appId
      }, {
        key: 'X-NAME',
        value: location
      }];
      this.upload.headers = headers;
      this.count = 1;
      this.upload.resume(files);
    });
    _defineProperty(this, "uploadAnother", () => {
      this.count = 0;
      this.setState({
        showSuccess: false,
        showMessage: false,
        message: null,
        messageType: ''
      });
    });
    this.state = this.initState();
  }
  initState() {
    var postUrl = endpoints.location.root + '/location/group';
    var accountData = account.get();
    return {
      location: '',
      showSuccess: false,
      showMessage: false,
      messageType: '',
      message: null,
      postUrl: postUrl,
      appId: accountData.tenantId
    };
  }
  componentDidMount() {
    this.count = 0;
    publishSearch('Locations');
    publishEvent('reset-search', {});
  }
  render() {
    if (manageDataLegacyHere()) return this.renderLegacy();
    return /*#__PURE__*/React.createElement("div", {
      className: "territory-view ec-view ecc-view aup-view"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ecc-top"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "ecc-back",
      "aria-label": "Back",
      onClick: this.onGoBack
    }, /*#__PURE__*/React.createElement("svg", {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      "aria-hidden": "true"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M10 3L5 8l5 5",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.8",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "ecc-titleblock"
    }, /*#__PURE__*/React.createElement("span", {
      className: "aup-title"
    }, "Upload markets"), /*#__PURE__*/React.createElement("span", {
      className: "ecc-meta"
    }, "Add your stores and the areas you sell or advertise in, all at once.")), /*#__PURE__*/React.createElement("span", {
      className: "ecc-spacer"
    })), this.state.showSuccess ? /*#__PURE__*/React.createElement("section", {
      className: "aup-card aup-done"
    }, /*#__PURE__*/React.createElement("b", null, "Your markets are uploading"), /*#__PURE__*/React.createElement("span", null, "They show up in Manage Data \u203A Markets within a few minutes."), /*#__PURE__*/React.createElement("span", {
      className: "aup-actions"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary",
      onClick: () => this.props.history.push("/Locations")
    }, "Go to your markets"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-base",
      onClick: this.uploadAnother
    }, "Upload another file"))) : /*#__PURE__*/React.createElement("div", {
      className: "aup-steps"
    }, /*#__PURE__*/React.createElement("section", {
      className: "aup-card"
    }, /*#__PURE__*/React.createElement("b", {
      className: "aup-h"
    }, "1 \xB7 Name this upload"), /*#__PURE__*/React.createElement("input", {
      className: "aup-input",
      type: "text",
      value: this.state.location,
      placeholder: "For example: Stores and sales areas 2026",
      onChange: this.onChange,
      onFocus: this.onFocus
    })), /*#__PURE__*/React.createElement("section", {
      className: "aup-card"
    }, /*#__PURE__*/React.createElement("div", {
      className: "aup-row"
    }, /*#__PURE__*/React.createElement("b", {
      className: "aup-h"
    }, "2 \xB7 Get your file ready"), /*#__PURE__*/React.createElement("span", {
      className: "ecc-spacer"
    }), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-base",
      onClick: this.onDownloadTemplate
    }, "Download a template")), /*#__PURE__*/React.createElement("span", {
      className: "aup-hint"
    }, "A CSV file with one row per market. A store needs its address; an area needs the ZIP codes (or map points) it covers. These columns are used when they're there:"), /*#__PURE__*/React.createElement("div", {
      className: "aup-groups"
    }, MainComponent.GROUPS.map(([g, cols]) => /*#__PURE__*/React.createElement("div", {
      key: g,
      className: "aup-group"
    }, /*#__PURE__*/React.createElement("span", {
      className: "aup-gl"
    }, g), /*#__PURE__*/React.createElement("span", {
      className: "aup-cols"
    }, cols.map(c => /*#__PURE__*/React.createElement("span", {
      key: c,
      className: "aup-col"
    }, c))))))), /*#__PURE__*/React.createElement("section", {
      className: "aup-card"
    }, /*#__PURE__*/React.createElement("b", {
      className: "aup-h"
    }, "3 \xB7 Upload the file"), /*#__PURE__*/React.createElement(MDCFileUpload, {
      cls: "aup-drop",
      singleFileUpload: true,
      postUrl: this.state.postUrl,
      onBeforeUpload: this.onBeforeUpload,
      onUploadError: this.onUploadError,
      onUploadComplete: this.onUploadComplete,
      onUploadProgressComplete: this.onUploadProgressComplete,
      ref: ref => this.upload = ref,
      accept: ".csv"
    }), this.state.showMessage && /*#__PURE__*/React.createElement("div", {
      className: "aup-msg" + (this.state.messageType === 'error' ? " bad" : "")
    }, String(this.state.message || "").replace(/^Error:\s*/, "")))));
  }
  renderLegacy() {
    return /*#__PURE__*/React.createElement(DetailContainer, {
      title: "Upload Locations",
      onGoBack: this.onGoBack
    }, this.state.showSuccess ? /*#__PURE__*/React.createElement(ProgressSuccess, {
      message: "Your locations file has been successfully uploaded."
    }) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "medium"
    }, "1. Prepare a File with your Location Data"), /*#__PURE__*/React.createElement("div", {
      className: "size-14"
    }, "Data types you can use:"), /*#__PURE__*/React.createElement("div", {
      className: "flex-data-types"
    }, /*#__PURE__*/React.createElement("div", null, "Reference Id"), /*#__PURE__*/React.createElement("div", null, "Name"), /*#__PURE__*/React.createElement("div", null, "Street Address"), /*#__PURE__*/React.createElement("div", null, "Street Address 2"), /*#__PURE__*/React.createElement("div", null, "City"), /*#__PURE__*/React.createElement("div", null, "Region"), /*#__PURE__*/React.createElement("div", null, "Postal Code"), /*#__PURE__*/React.createElement("div", null, "Country"), /*#__PURE__*/React.createElement("div", null, "Website Url"), /*#__PURE__*/React.createElement("div", null, "Email Address"), /*#__PURE__*/React.createElement("div", null, "Phone Number"), /*#__PURE__*/React.createElement("div", null, "Impression Weight"), /*#__PURE__*/React.createElement("div", null, "GeoTarget Postal Codes"), /*#__PURE__*/React.createElement("div", null, "GeoTarget Coordinates")), /*#__PURE__*/React.createElement("a", {
      className: "size-14-hover",
      onClick: this.onDownloadTemplate
    }, "Download Template"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
      className: "medium"
    }, "2. Name"), /*#__PURE__*/React.createElement("div", {
      className: "form-width"
    }, /*#__PURE__*/React.createElement(MDCTextInput, {
      label: "Name your locations list",
      value: this.state.location,
      onChange: this.onChange,
      onFocus: this.onFocus
    })), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
      className: "medium"
    }, "3. Add Your File"), /*#__PURE__*/React.createElement(MDCFileUpload, {
      singleFileUpload: true,
      postUrl: this.state.postUrl,
      onBeforeUpload: this.onBeforeUpload,
      onUploadError: this.onUploadError,
      onUploadComplete: this.onUploadComplete,
      onUploadProgressComplete: this.onUploadProgressComplete,
      ref: ref => this.upload = ref,
      accept: ".csv"
    }), this.state.showMessage && /*#__PURE__*/React.createElement(AlertMessage, {
      message: this.state.message,
      cls: this.state.messageType
    })), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null));
  }
}
// File columns, grouped and named the way people think of them (the file headers stay as in the template).
_defineProperty(MainComponent, "GROUPS", [["Identify it", ["Reference Id", "Name"]], ["Address", ["Street Address", "Street Address 2", "City", "Region", "Postal Code", "Country"]], ["Contact", ["Website Url", "Email Address", "Phone Number"]], ["Area it covers", ["GeoTarget Postal Codes", "GeoTarget Coordinates"]], ["Ad weighting", ["Impression Weight"]]]);
export class UploadLocationViewComponent extends BaseDataViewComponent {
  constructor(props) {
    super(props);
  }
  fetchData() {
    setTimeout(() => {
      this.allowRender = true;
      this.data = {};
      this.forceUpdate();
    }, 100);
  }
  render() {
    if (!this.allowRender) {
      return null;
    } else {
      return /*#__PURE__*/React.createElement(RoutableComponent, {
        data: this.data,
        params: this.props.params
      });
    }
  }
}
const RoutableComponent = withRouter(MainComponent);
export default {
  UploadLocationViewComponent
};